module.exports = __webpack_public_path__ + "img/monitoring-bus-track.233dce35.svg";